import { useEffect, useState } from 'react';

const getMobileBreakpoint = () => {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--breakpoint-mobile')
    .trim();

  return parseInt(value.replace('px', ''), 10);
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const breakpoint = getMobileBreakpoint();

    const check = () => {
      const isMobileCondition = window.innerWidth < breakpoint;

      setIsMobile(isMobileCondition);
    };

    check();

    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
};
